import { Application } from '@/types/application';
import { Detail, emptyValue } from '@/types/detail';
import { Configuration, Metadata } from '@/types/metadata/metadata';
import { ValidationError, ValidationObject } from '@/types/validation';
import { VariableRef } from '@/types/variable';
import { isArray, isObject } from '@/util/typeGuards';
import { variableUtil } from './variable';

export const variablesListUtil = (): ValidationObject<(VariableRef | emptyValue)[] | undefined> => {
  const validateVariableslist = (
    application: Application,
    metadata: Metadata,
    linkedSubroutineId: number,
    nodeId: number,
    blockName: string,
    configuration: Configuration,
    details: Detail
  ): ValidationError[] => {
    const errors: ValidationError[] = [];
    const variables = getValue(configuration, details);
    if (configuration.required && !variables?.length) {
      errors.push({
        severity: 'error',
        message: `Block ${blockName} is missing required variables: ${configuration.label}`,
        id: nodeId
      });
    }
    const validatedVars = variables
      ?.map((variable) =>
        variableUtil().validate(application, metadata, linkedSubroutineId, nodeId, blockName, configuration, variable)
      )
      .flat();
    if (validatedVars?.length) {
      errors.push(...validatedVars);
    }
    return errors;
  };

  const getValue = (configuration: Configuration, initVal: unknown): (VariableRef | emptyValue)[] | undefined => {
    if (!initVal) return;
    if (isArray(initVal)) {
      return initVal;
    }
    if (isObject(initVal)) {
      const prop = initVal[configuration.value];
      return getValue(configuration, prop);
    }
    return;
  };

  return {
    validate: validateVariableslist,
    getValue: getValue
  };
};
